import type { PurchaseOrderStatus } from "@/server/platform/db/schema/purchase-orders";
import { Badge } from "@/components/ui/badge";
import { PO_STATUS_LABELS } from "./purchaseLaoLabels";

const VARIANT: Record<
  PurchaseOrderStatus,
  "default" | "secondary" | "destructive" | "outline"
> = {
  DRAFT: "secondary",
  SUBMITTED: "default",
  APPROVED: "outline",
  PARTIALLY_RECEIVED: "default",
  RECEIVED: "outline",
  CLOSED: "secondary",
  CANCELLED: "destructive",
};

export function PurchaseOrderStatusBadge({
  status,
}: {
  status: PurchaseOrderStatus | string;
}) {
  const key = status as PurchaseOrderStatus;
  const label = PO_STATUS_LABELS[key] ?? status;
  const variant = VARIANT[key] ?? "secondary";
  return <Badge variant={variant}>{label}</Badge>;
}
